import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { FormStateService } from '../../module/service-provider/add-sp-new-component/form-state.service';
import { ToastService } from '../../Service/ToastService/toast.service';
import { Location } from '@angular/common';
import { ReloadService } from '../../Service/Reload-service/reload.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-service-distributor-details',
  templateUrl: './service-distributor-details.component.html',
  styleUrl: './service-distributor-details.component.scss'
})
export class ServiceDistributorDetailsComponent implements OnInit {

  serviceDistributorName = '';
  businessName = '';
  coiDocument: any = null;
  iodDocument: any = null;
  imgPath = '';
  emailAddress = '';
  address = '';
  name = '';
  ownerName = '';
  contact = '';
  status = '';
  businessType = '';
  submittedBy = '';
  email = '';
  gst = '';
  countryId = '';
  state = '';
  stateId = '';
  city = '';
  zip = '';
  district = '';
  districtId = '';
  date = '';
  commencementYear = '';
  website = '';
  authorisedDelarshipProofUrl = '';
  commercialRegistrationNumber = '';
  documentName = '';
  planName = 'Basic';
  paidAmount = '₹299/-';
  distributorId: any;
  servicedistributor: any;
  userName = '';
  garageInChargeName = '';
  distributorNetworks: any[] = [];
  documents: any[] = [];
  frontViewFiles: any[] = [];
  selectedDocumentUrl: string | undefined;
  visible = false;
  visibleReject = false;
  visibleViewer = false;
  showDocumentViewer = false;
  garageInChargePhoneNumber = '';
  ownerEmailAddress = '';
  ownerPhoneNumber = '';
  applicantEmailAddress = '';
  showModal = false;
  idToEdit!: any;
  data: any;
  events: any;
  showAllServices: boolean = false;
  visibleHistory: boolean = false;
  visibleDelete: boolean = false;
  reviewModal = false;
  rejectionNote: string = '';
  agreementFileUrl: string = '';
  agreementFile: any = null;
  model: any = {};
  @Input() phoneNumber: any
  showSettingsModal: boolean = false;
  distributorDocuments: any[] = [];

   disableModalVisible = false;
selectedDistributorDetails: any = {};
availableDistributors: any[] = [];
  // shares
  sharesList: any = [];
  addBalanceModal: boolean = false
  accessType: any
  sanitizedDocumentUrl: SafeResourceUrl | undefined;
   @Output() onFinish = new EventEmitter<void>();
    @Output() close: EventEmitter<any> = new EventEmitter();
    // @Input() distributorId: any;

  constructor(
    private dialogService: DialogService,
    private route: ActivatedRoute,
    private api: ServiceProviderService,
    private formStateService: FormStateService,
    private cdr: ChangeDetectorRef,
    private toastService: ToastService,
    private location: Location,
    private router: Router,
    private reloadService: ReloadService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.reloadService.reloadList$.subscribe(() => {
      console.log('Reload triggered by custom dialog');
      this.getServiceDistributorDetails();
    });
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.accessType = user?.accessType ?? -1;
    console.log('Access type = ', this.accessType)
    this.phoneNumber = history.state?.phoneNumber;

    this.route.paramMap.subscribe((params) => {
      this.distributorId = params.get('distributorId');
      this.formStateService.setServiceDistributorId(this.distributorId);
      this.formStateService.setUserId(this.distributorId);
      this.getServiceDistributorDetails();
    });

    this.distributorId = this.route.snapshot.paramMap.get('distributorId');
    const storedAgreementFile = this.formStateService.getApproveData('agreementFile');
    if (storedAgreementFile && storedAgreementFile.filePath) {
      this.agreementFileUrl = storedAgreementFile.filePath;
      console.log('Retrieved Agreement File:', this.agreementFileUrl);
    } else {
      console.warn('No Agreement File found in FormStateService');
    }


  }
  refreshDetails() {
    this.closeApproveModal();
    console.log('Refresh Details is called')
    this.getServiceDistributorDetails();
    setTimeout(() => {
      this.cdr.detectChanges();
    });
  }

  refreshAfterReview() {
  this.closeReviewModal();  
  console.log('Refresh After Review is called');
  this.getServiceDistributorDetails();
  setTimeout(() => {
    this.cdr.detectChanges();
  });
}

  getServiceDistributorDetailsById() {
    this.closeRejectModal();
    this.getServiceDistributorDetails();
  }

  
  getServiceDistributorDetails() {
    if (!this.distributorId) {
      console.error("Distributor ID is missing.");
      return;
    }
    this.api.getDistributorById(this.distributorId).subscribe(
      (res: any) => {
        console.log("Full API ResponseD:", res);
        this.servicedistributor = res;
        this.businessName = res.businessName;
        this.name = res.ownerName;
        this.emailAddress = res.emailAddress;
        this.contact = res.phoneNumber;
        this.businessType = res.businessType?.name || 'Not available';
        this.commencementYear = res.yearOfEstablishment;
        this.website = res.website;
        this.authorisedDelarshipProofUrl = res.authorisedDelarshipProofUrl;
        this.commercialRegistrationNumber = res.commercialRegistrationNumber;
        this.gst = res.gstNumber || 'Not provided';
        this.status = res.status;
        this.city = res.city;
        this.zip = res.zip;
        this.district = res.district;
        this.address = res.address;
        this.state = res.state?.name;
        this.countryId = res.country?.name || 'Unknown';
        this.ownerPhoneNumber = res.ownerPhoneNumber;
        this.ownerEmailAddress = res.ownerEmailAddress;
        this.distributorNetworks = res.distributorNetworks?.map((network: any) => ({
          serviceProviderTypeId: network.serviceProviderTypeId,
          name: network.name,
          distributorNetworkSubTypes: network.distributorNetworkSubTypes?.map((sub: any) => ({
            serviceProviderSubTypeId: sub.serviceProviderSubTypeId,
            name: sub.name,
            count: sub.count || 0
          })) || []
        })) || [];

        
        this.documents = res.documents || [];
        this.coiDocument = res.documents.find((doc: any) => doc.documentTypeId === 6) || null;
        this.iodDocument = res.documents.find((doc: any) => doc.documentTypeId === 19) || null;
        //this.frontViewFiles = res.frontViewFiles 
        this.agreementFileUrl = res.agreementFile?.filePath || '';
        this.rejectionNote = res.rejectReason
        this.imgPath = res.frontViewFiles?.length ? res.frontViewFiles[0].filePath : '';

        console.log("Front View Image Path:", this.imgPath);
        console.log('response fron apiiii', res.agreementFilePath)
        console.log('responseDOC', res.documents)
        console.log('responseFrontView', res.frontViewFiles)
        this.cdr.detectChanges();
      },
      (error) => {
        console.error("Error fetching distributor details:", error);
      }
    );
    console.log("Distributor Details:", this.servicedistributor);

  }

  getBusinessNetworks() {
    return this.distributorNetworks.reduce(
      (total, network) => total + network.distributorNetworkSubTypes.reduce((sum: any, subtype: any) => sum + subtype.count, 0),
      0
    );
  }

  get truncatedwebsite(): string {
    const maxLength = 14;
    if (this.website.length > maxLength) {
      return this.website.substring(0, maxLength) + '.....';
    } else {
      return this.website;
    }
  }
  get truncatedauthorisedDelarshipProofUrl(): string {
    const maxLength = 14;
    if (this.authorisedDelarshipProofUrl.length > maxLength) {
      return this.authorisedDelarshipProofUrl.substring(0, maxLength) + '.....';
    } else {
      return this.authorisedDelarshipProofUrl;
    }
  }

  subDomainName() {
    // set sub-domain name
    const subDomainName = this.serviceDistributorName!.toLowerCase().replace(
      /\s+/g,
      ''
    );
    this.formStateService.setSubDomainName(subDomainName);
  }

  get truncatedServiceDistributorName(): string {
    const maxLength = 50;
    if (this.serviceDistributorName.length > maxLength) {
      return this.serviceDistributorName.substring(0, maxLength) + '....';
    } else {
      return this.serviceDistributorName;
    }
  }

  viewOwnerIdProof() {
    const doc = this.documents.find(doc => doc.documentTypeId === 7);
    console.log('Document is 7', doc.filePath)
    this.openViewer(doc.filePath);
  }


  viewOwnerCV() {
    const doc = this.documents.find(doc => doc.documentTypeId === 20);
    this.openViewer(doc.filePath);
  }

  viewCOIProof() {
    const doc = this.documents.find(doc => doc.documentTypeId === 6);
    if (doc?.filePath) {
      this.openViewer(doc.filePath);
    } else {
      this.toastService.showToast('Certificate of Incorporation not available', 'error');
    }
  }

  viewIODProof() {
    const doc = this.documents.find(doc => doc.documentTypeId === 19);
    if (doc?.filePath) {
      this.openViewer(doc.filePath);
    } else {
      this.toastService.showToast('Insurance of dealership Proof not available', 'error');
    }
  }

  viewCRNProof() {
    const doc = this.documents.find(doc => doc.documentTypeId === 17);
    if (doc?.filePath) {
      this.openViewer(doc.filePath);
    } else {
      this.toastService.showToast('CRN Proof not available', 'error');
    }
  }


  viewAgreement() {
    if (this.agreementFileUrl) {
      this.openViewer(this.agreementFileUrl);
      // window.open(this.agreementFileUrl, '_blank');
    } else {
      this.toastService.showToast('Agreement file not available', 'error');
    }
  }

  viewAddressProof() {
  const doc = this.documents.find(doc => doc.documentTypeId === 5);
  if (doc?.filePath) {
    this.openViewer(doc.filePath);
  } else {
    this.toastService.showToast('Address Proof not available', 'error');
  }
}


  closeViewer() {
    this.visibleViewer = false;
    this.selectedDocumentUrl = undefined;
  }
  isPdf(url: string | undefined): boolean {
    if (!url) return false;
    const cleanUrl = url.split('?')[0];
    return cleanUrl.toLowerCase().endsWith('.pdf');
  }


  delete() {
  this.visibleDelete = false;

  if (!this.distributorId) {
    console.error('Distributor ID is missing');
    this.toastService.showToast('Distributor ID not found.','error');
    return;
  }

  this.api.deleteDistributor(this.distributorId).subscribe({
    next: (res) => {
      if (res.isSuccess) {
        this.toastService.showToast(res.result || 'Distributor deleted successfully.', 'success');
        this.close.emit();
        this.onFinish.emit();
        this.location.back()
      } else {
        this.toastService.showToast('Failed to delete distributor.', 'error');
      }
    },
    error: (err) => {
      console.error('Error deleting distributor:', err);
      this.toastService.showToast('Something went wrong while deleting the distributor.', 'error');
    }
  });
}


  showDeleteDialog() {
    this.visibleDelete = true;
  }


openDisableModal(distributorId: string) {
  this.disableModalVisible = true;
  this.api.getDistributorDetails(+distributorId).subscribe((res: any) => {
    this.selectedDistributorDetails = {
      name: res.name,
      address: res.address, // 'location' field might be named 'address' as per response
      totalSpCount: res.totalSpCount,
      totalCustomerCount: res.totalCustomerCount,
      distributorId: res.distributorId,
    };
    this.disableModalVisible = true;
  });

  // Second API call: Get all available distributors for reassignment
  this.api.getAvailableDistributors().subscribe((res: any) => {
    this.availableDistributors = res;
  });
}

closeDisableModal() {
  this.disableModalVisible = false;
}

loadDistributorDetails() {
  this.closeDisableModal();
  this.getServiceDistributorDetails();
  setTimeout(() => {
    this.cdr.detectChanges();
  });
}


  approve() {
    console.log('Approve button is clicked');
    this.visible = true;
    this.subDomainName();
  }
  viewer() {
    this.visibleViewer = true;
  }

  reject() {
    this.visibleReject = true;
  }

  closeApproveModal(): void {
    this.visible = false;
  }

  closeRejectModal(): void {
    this.visibleReject = false;
  }

  displayHistory() {
    this.visibleHistory = true;
    this.api.getDistributorHistory(this.distributorId).subscribe((data: any) => {
      console.log(data);
      this.events = data;
    });
  }

  toggleShowAllServices() {
    this.showAllServices = !this.showAllServices;
  }
  inreview() {
    this.reviewModal = true;
  }
  closeReviewModal() {
    this.reviewModal = false;
  }
  markForReview() {
    this.reviewModal = false;
  }
  goBack() {
    this.location.back()
  }

  //  share
  resetShareEditingState() {
    this.sharesList.forEach((share: any) => {
      share.isEditing = false;
    });
  }
  fetchSharesFromBackend() {
    // this.api.getShares().subscribe((res) => this.sharesList = res);
    this.sharesList = this.sharesList.map((item: any) => ({
      ...item,
      isEditing: false
    }));
  }

  enableEdit(index: number) {
    this.sharesList[index].isEditing = true;
  }

  disableEdit(index: number) {
    this.sharesList[index].isEditing = false;
  }

  saveShares() {
    const payload: any = {};
    this.sharesList.forEach((item: any) => {
      payload[item.key] = item.share;
    });

    this.api.saveDistributorPaymentSettings(this.servicedistributor.distributorId, payload)
      .subscribe({
        next: (res) => {
          this.toastService.showToast('Commission settings saved successfully', 'success');
          this.showSettingsModal = false;
        },
        error: (err) => {
          this.toastService.showToast('Failed to save settings', 'error');
        }
      });
  }


  getShareByName(name: string): number {
    const share = this.sharesList.find((item: any) => item.name === name);
    return share ? +share.share : 0;
  }

  openShareModal() {
    this.resetShareEditingState();

    this.api.getDistributorPaymentSettings(this.servicedistributor.distributorId).subscribe((res) => {
      this.sharesList = [
        {
          name: 'Vehicle Service Provider',
          key: 'serviceProviderCommission',
          share: res.serviceProviderCommission ?? 0,
          isEditing: false,
        },
        {
          name: 'Vehicle Owner',
          key: 'serviceSeekerCommission',
          share: res.serviceSeekerCommission ?? 0,
          isEditing: false,
        },
        {
          name: 'Technical Advisor',
          key: 'serviceAdvisorCommission',
          share: res.serviceAdvisorCommission ?? 0,
          isEditing: false,
        },
        {
          name: 'Tax Rate',
          key: 'taxRate',
          share: res.taxRate ?? 0,
          isEditing: false,
        },
        {
          name: 'Tax Name',
          key: 'taxName',
          share: res.taxName ?? '',
          isEditing: false,
        },
      ];
      this.showSettingsModal = true;
    });

  }
  isSaveDisabled(): boolean {
    const taxEntry = this.sharesList.find((item: any) => item.key === 'taxName');
    return !taxEntry || !taxEntry.share || taxEntry.share.trim() === '';
  }
  openAddBalance() {
    this.addBalanceModal = true
  }
  editDistributor(distributorId: number, phoneNumber: string): void {
    this.router.navigate([`edit-distributor-partner`], {
      relativeTo: this.route,
      queryParams: {
        phone: phoneNumber
      }
    });
  }

  openViewer(url: string) {
    console.log('Opening viewer with URL:', url);
    this.selectedDocumentUrl = url;
    this.sanitizedDocumentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.visibleViewer = true;
  }
  pdfLoaded(pdf: any) {
    console.log('PDF loaded with total pages:', pdf.numPages);
  }
}
